/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    appName: '文殊の知恵袋',
    ok: 'OK',
    cancel: 'キャンセル',
    confirmTitle: '確認',
    signIn: 'サインイン',
    signOut: 'サインアウト',
    profile: 'プロフィール',
    mainMenu: 'MAIN MENU',
    userAdminMenu: 'ADMIN MENU',
    sysAdminMenu: 'SYSTEM ADMIN MENU',
    msg: {
      signOutConfirm: 'サインアウトします。よろしいですか？',
    }
  },
  entities: {},
  pages: {
    top: {
      title: 'トップページ',
    },
    sampleList: {
      title: "サンプルリストページ",
      listHeader: "○○○一覧",
      createButton: "新規作成",
    }
  },
};
